export const EASE_OUT: [number, number, number, number] = [0.23, 1, 0.32, 1];

export const fadeUp = {
  initial: { opacity: 0, y: 14 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4, ease: EASE_OUT },
};

export const stagger = {
  animate: { transition: { staggerChildren: 0.05, delayChildren: 0.1 } },
};
